import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { DropdownOption } from '../../components/UI/multi-select-dropdown/MultiSelectDropdown'

interface GapAnalysisState {
  pageToFetch: number
  showManageViewModal: boolean
  showSaveViewModal: boolean
  hasInTrainingStatus: boolean
  hashKey?: string
  selectedView?: DropdownOption
}

const initialState: GapAnalysisState = {
  pageToFetch: 1,
  showManageViewModal: false,
  showSaveViewModal: false,
  hasInTrainingStatus: false
}

const gapAnalysisSlice = createSlice({
  name: 'gapAnalysis',
  initialState,
  reducers: {
    setPageToFetch(state, action: PayloadAction<number>) {
      state.pageToFetch = action.payload
    },
    setShowManageViewModal(state, action: PayloadAction<boolean>) {
      state.showManageViewModal = action.payload
    },
    setShowSaveViewModal(state, action: PayloadAction<boolean>) {
      state.showSaveViewModal = action.payload
    },
    setHasInTrainingStatus(state, action: PayloadAction<boolean>) {
      state.hasInTrainingStatus = action.payload
    },
    setHashKey(state, action: PayloadAction<string | undefined>) {
      state.hashKey = action.payload
    },
    setSelectedView(state, action: PayloadAction<DropdownOption | undefined>) {
      state.selectedView = action.payload
    }
  }
})

export const gapAnalysisReducer = gapAnalysisSlice.reducer
export const gapAnalysisActions = {
  ...gapAnalysisSlice.actions
}
